const siteLocationFormSchema = {
  type: 'object',
  required: ['siteId', 'name', 'siteLocationType'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
  },
};

export { siteLocationFormSchema };
